module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I must thank those who have provided timely advice, steadfast support, and engaged interest during the lengthy and time-consuming process of bringing a book to a conclusion. Thanks go out to Sohail Daulatzai and his brother Yusef for the much-needed, deep discussions about basketball that allowed me to clear my mind for each successive stage of this book. I give much thanks to Casey Kittrell for his humor and professionalism in answering a variety of inquiries and technical riddles. A hearty thank you goes to Victoria Davis for her editorial direction and Laura Griffin for her insightful and clarifying copy-editing. I have to make a special point of recognition for Jim Burr, my sponsoring editor at the University of Texas Press. His commitment, openness, and appreciation of the superhero comic book and film genres were invaluable as the book went from idea, working draft, and final manuscript to done deal. He is a master editorial juggler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well-deserved thanks go out to George Huang and his staff over at Comics Factory in Pasadena, California. Sean Jackson pointed me in the right direction, and Kris Zaycher was particularly helpful, with his insights and information that kept me up to date with the mercurial world of comic book characters. In addition, Aaron Johnson and Gene Coty, Jr., facilitated completion of this project with their technical know-how. Lastly, I would be all talk and my ideas a figment of a vivid imagination without my beloved Tamu, Nia, and Nizam. Your cheer, smiles, patience, and reluctant willingness to let me “woodshed on the piece” made all the difference.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a534203","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292735453_06_ack.vue
// module id = 75
// module chunks = 0